<template>
    <div>
        <H1>Page Not Found</H1>
    </div>

</template>

<script>


export default {


 data() {
    return {

    }
 }
}
</script>